module.exports = __webpack_public_path__ + "img/III-31.6622c93b.svg";